module.exports = __webpack_public_path__ + "svg/login-tree.svg";